import { render, staticRenderFns } from "./MobileNotifications.vue?vue&type=template&id=0d88eddf&scoped=true&"
import script from "./MobileNotifications.js?vue&type=script&lang=js&"
export * from "./MobileNotifications.js?vue&type=script&lang=js&"
import style0 from "./MobileNotifications.scss?vue&type=style&index=0&id=0d88eddf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d88eddf",
  null
  
)

export default component.exports